import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ComponentsService } from 'src/app/components.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-ccy-management',
    templateUrl: './ccy-management.component.html',
    styleUrls: ['./ccy-management.component.scss']
})
export class CcyManagementComponent implements OnInit, OnDestroy {
    selectedTab: number = 0;
    selectedDate: Date = new Date();
    selectedRowId: string | null = null;

    displayCcyArr = [];
    selectedDisplayCcy: string | undefined = undefined;

    dataSourceCurrency: MatTableDataSource<Currency>;
    columnsCurrency: string[] = ['id', 'name', 'currency_code', 'round_points'];

    dataSourceLatestXR: MatTableDataSource<LatestXR>;
    columnsLatestXR: string[] = [
        'id',
        'base_currency',
        'currency_code',
        'rate',
        'updated_at'
    ];

    dataSourceXR_history: MatTableDataSource<XR_history>;
    columnsXrHistory: string[] = [
        'id',
        'base_currency',
        'currency_code',
        'rate',
        'date'
    ];
    historyFilter = {
        currency_code: '',
        rate: '',
        date: ''
    };
    private clientChangeSubscription?: Subscription;

    constructor(
        private service: ComponentsService,
        private datePipe: DatePipe
    ) {}

    ngOnInit(): void {
        this.getCurrencies();
        this.getExchangeRate();
        this.getExchangeRateHistory();
        this.getDisplayCcy();

        this.clientChangeSubscription = this.service.clientChanged.subscribe(
            (client) => {
                if (client?.clientUuid) {
                    this.service.setClientUuid(client.clientUuid);
                    this.refreshAllData();
                }
            }
        );
    }

    ngOnDestroy(): void {
        this.clientChangeSubscription?.unsubscribe();
    }

    private refreshAllData(): void {
        this.getCurrencies();
        this.getExchangeRate();
        this.getExchangeRateHistory();
        this.getDisplayCcy();
    }

    getCurrencies(): void {
        this.service.getCurrency().subscribe((data: Currency[]) => {
            // Implement further handling of the data here
            this.dataSourceCurrency = new MatTableDataSource<Currency>(data);
        });
    }

    getExchangeRate() {
        this.service.getExchangeRate().subscribe((data: LatestXR[]) => {
            this.dataSourceLatestXR = new MatTableDataSource<LatestXR>(data);
        });
    }

    getExchangeRateHistory(): void {
        const formattedDate = this.datePipe.transform(
            this.selectedDate,
            'yyyy-MM-dd'
        )!;
        this.service
            .getExchangeRateHistory(formattedDate, this.selectedDisplayCcy)
            .subscribe((data: XR_history[]) => {
                this.dataSourceXR_history = new MatTableDataSource<XR_history>(
                    data
                );
                this.dataSourceXR_history.filterPredicate = (
                    row: XR_history,
                    filter: string
                ) => {
                    if (!filter) {
                        return true;
                    }
                    const parsed = JSON.parse(filter);
                    const currency = (parsed.currency_code || '').toLowerCase();
                    const rate = (parsed.rate || '').toLowerCase();
                    const date = (parsed.date || '').toLowerCase();

                    const matchesCurrency = currency
                        ? (row.currency_code || '')
                              .toLowerCase()
                              .includes(currency)
                        : true;
                    const matchesRate = rate
                        ? String(row.rate || '')
                              .toLowerCase()
                              .includes(rate)
                        : true;
                    let formattedDate = this.datePipe.transform(
                        row.date,
                        'dd/MM/yyyy'
                    );
                    formattedDate = formattedDate
                        ? formattedDate.toLowerCase()
                        : '';
                    const matchesDate = date
                        ? formattedDate.includes(date)
                        : true;
                    return matchesCurrency && matchesRate && matchesDate;
                };
                this.applyHistoryFilter();
            });
    }

    highlightRow(row: { id: string }) {
        // Provera da li je trenutni red već selektovan
        if (this.selectedRowId === row.id) {
            // Ako jeste, poništite selekciju
            this.selectedRowId = null;
        } else {
            // Inače, označite novi red kao selektovan
            this.selectedRowId = row.id;
        }
    }

    // Removed getBaseCcy() - backend now enforces client's defaultCcy for both tabs

    getDisplayCcy() {
        this.service.getDisplayCcy().subscribe((data) => {
            this.displayCcyArr = data;
        });
    }

    onDateChange(): void {
        this.getExchangeRateHistory();
    }

    resetFilters() {
        this.selectedDisplayCcy = undefined;
        this.selectedDate = new Date();
        this.getExchangeRateHistory();
    }

    applyHistoryFilter(): void {
        if (this.dataSourceXR_history) {
            this.dataSourceXR_history.filter = JSON.stringify(
                this.historyFilter
            );
        }
    }

    clearHistoryFilter(): void {
        this.historyFilter = {
            currency_code: '',
            rate: '',
            date: ''
        };
        this.applyHistoryFilter();
    }
}

export interface XR_history {
    id: string;
    base_currency: string;
    currency_code: string;
    rate: number;
    date: string | Date;
}
export interface Currency {
    id: string;
    name: string;
    currency_code: string;
    round_points: number;
}

export interface LatestXR {
    id: string;
    base_currency: string;
    currency_code: string;
    rate: number;
    updated_at: string | Date;
}
